module.exports = __webpack_public_path__ + "img/zhongsanjiniantang.b1ef58ed.png";